import * as React from "react";
import { SVGProps } from "react";
const SvgTelevision = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 26c0 .6-.4 1-1 1H10c-.6 0-1-.4-1-1s.4-1 1-1h12c.6 0 1 .4 1 1Zm6-22c1.1 0 2 .9 2 2v15c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h26ZM3 21h26V6H3v15Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTelevision;
